<div class="minor-account-not-found">
  <div class="minor-account-not-found-icon">
    <se-fe-icon
      seFeDataName="spot_whistle"
      seFeDataSize="950"
      seFeDataAriaLabel="whistle"
      [seFeDataMargin]="false"
    ></se-fe-icon>
  </div>
  <div class="minor-account-not-found-title">
    <se-po-highlight-label
      label="Oops! We couldn't find what you're looking for"
    ></se-po-highlight-label>
  </div>
</div>
